var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGreenCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 104,
    viewBox: "0 0 104 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "gg:check-o"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M44.3863 70.694L26 52.3033L32.1273 46.176L44.3863 58.4307L68.8957 33.917L75.0273 40.0487L44.3863 70.6853V70.694Z",
    fill: "#16DD19"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.33325 52C4.33325 25.675 25.6749 4.33337 51.9999 4.33337C78.3249 4.33337 99.6666 25.675 99.6666 52C99.6666 78.325 78.3249 99.6667 51.9999 99.6667C25.6749 99.6667 4.33325 78.325 4.33325 52ZM51.9999 91C46.8784 91 41.807 89.9913 37.0753 88.0313C32.3436 86.0714 28.0442 83.1987 24.4228 79.5772C20.8013 75.9557 17.9286 71.6564 15.9686 66.9247C14.0087 62.193 12.9999 57.1216 12.9999 52C12.9999 46.8785 14.0087 41.8071 15.9686 37.0754C17.9286 32.3437 20.8013 28.0444 24.4228 24.4229C28.0442 20.8014 32.3436 17.9287 37.0753 15.9687C41.807 14.0088 46.8784 13 51.9999 13C62.3434 13 72.2632 17.109 79.5771 24.4229C86.891 31.7368 90.9999 41.6566 90.9999 52C90.9999 62.3435 86.891 72.2633 79.5771 79.5772C72.2632 86.8911 62.3434 91 51.9999 91Z",
    fill: "#16DD19"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenCheck);
export default __webpack_public_path__ + "static/media/green-check.10a9714248c92e6f5de1ad91e55b1a9a.svg";
export { ForwardRef as ReactComponent };